"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var normalization_1 = require("../../../util/resources/normalization");
var ap_1 = tslib_1.__importDefault(require("../ap"));
var validation_1 = require("../../../util/resources/validation");
var normalization_2 = require("rest-resource/dist/helpers/normalization");
var CheckResource = /** @class */ (function (_super) {
    tslib_1.__extends(CheckResource, _super);
    function CheckResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckResource.related = function () {
        return Object.assign({}, index_1.BaseTransactionResource.related(), {
            related_transactions: ap_1.default,
        });
    };
    CheckResource.endpoint = '/checks';
    CheckResource.MODEL_NAME = 'papercheck';
    CheckResource.normalization = {
        account_clearing: normalization_2.normalizerFactory('StringNormalizer'),
        account_cash: normalization_2.normalizerFactory('StringNormalizer'),
        related_transactions: normalization_2.normalizerFactory('StringNormalizer'),
        vendor: normalization_2.normalizerFactory('StringNormalizer'),
        batch: normalization_2.normalizerFactory('StringNormalizer'),
        description: normalization_2.normalizerFactory('StringNormalizer'),
        amount_decimal: normalization_2.normalizerFactory('CurrencyNormalizer'),
        date: new normalization_1.DateNormalizer(),
        recon: normalization_2.normalizerFactory('StringNormalizer'),
    };
    CheckResource.validation = validation_1.extendValidators(index_1.BaseTransactionResource, {
        amount_decimal: [validation_1.isValidCurrency('amount_decimal')],
    });
    return CheckResource;
}(index_1.BaseTransactionResource));
exports.default = CheckResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/check/index.js
// module id = qhSm
// module chunks = 0